import { Backdrop, Box, Card, Collapse, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import Loader from "../../../SAPPages/components/Loader/Loader";
import BlueMediumButton from "../../components/customButtons/BlueMediumButton";
import NoClasseEnrolledScreen from "../classrooom/selectedClassDetails/NoClassEnrolledScreen";
import CustomPafinationComp from "../allClasses/CustomPafinationComp";
import ErrorPopupScreen from "../../components/customPopup/ErrorPopupScreen";
import {
  genratePaymentReceipt,
  getAllSubTestTypeList,
  getClasses,
  getPaymentModes,
  getPayments,
  getPaymentStatus,
  getRealTestTestTypes,
  getTestPaymentHistory,
  getTestTypeList,
} from "../testPrepDashboard/Api/DashboardApi";
import { pdf } from "@react-pdf/renderer";
import ViewPaymentInvoice from "./ViewPaymentInvoice";
import { useLocation } from "react-router-dom";
import GlobalCard from "../../components/GlobalCardComponent";
import CustomSelect from "../../components/customFields/CustomSelect";
import BlueOutlinedButton from "../../components/customButtons/BlueOutlineButton";
import CustomTextField from "../../components/customFields/CustomTextField";
import { genrateTestPaymentReceipt } from "../performance/purchaseTest/PurchaseTestApis";
import TestPaymentReceipt from "./TestPaymentReceipt";

export default function TestPaymentHistory({ expanded }) {
  const userId = localStorage.getItem("userId");
  const location = useLocation();
  const [paymentLoading, setPaymentLoading] = useState(true);
  const [selectedClass, setSelectedClass] = useState([]);
  const [testTypeList, setTestTypeList] = useState([]);
    const [subTestTypeList, setSubTestTypeList] = useState([]);
  const [testType, setTestType] = useState([]);
    const [SubtestType, setSubTestType] = useState([]);
  const [paymentMode, setPaymentMode] = useState([]);
  const [durationOption, setDurationOption] = useState([
    { id: 1, label: "Last 30 days", value: "last_30_days", days: 30 },
    { id: 2, label: "Last 60 days", value: "last_60_days", days: 60 },
    { id: 3, label: "Last 90 days", value: "last_90_days", days: 90 },
    { id: 4, label: "Custom", value: "custom", days: null },
  ]);
  const [duration, setDuration] = useState("last_30_days");
  const [paymentStartDate, setPayemntStartDate] = useState(null);
  const [paymentEndDate, setPayemntEndDate] = useState(null);
  const [paymentModeList, setPaymentModeList] = useState([]);
  const [pagination, setPagination] = useState(null);
  const [originalPagination, setOriginalPagination] = useState(null);
  const [paymentData, setPaymentData] = useState([]);
  const [originalPayment, setOriginalPayments] = useState([]);
  const [page, setPage] = useState(1);
  const [statuslist, setStatusList] = useState([]);
  const [status, setStatus] = useState([]);
  const [classList, setClassList] = useState([]);
  const [receiptData, setReceiptData] = useState([]);
  const [receiptLoading, setReceiptLoading] = useState(false);
  const [openErrorPopup, setOpenErrorPopup] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const todaysDate = new Date().toISOString().split("T")[0];

  const handleFetchPayments = async (page) => {
    setPaymentLoading(true);
    try {
      const response = await getTestPaymentHistory({
        user_id: parseInt(userId),
         test_type_id: testType,
        sub_test_type_id: SubtestType,
        payment_mode: paymentMode,
        page,
        limit: 3,
        status: status,
        start_date: paymentStartDate,
        end_date: paymentEndDate,
        filter: duration,
      });

      if (response.status === 200) {
        setPaymentData(response?.data);
        setPagination(response?.pagination);
        setOriginalPagination(response?.pagination);
        setOriginalPayments(response?.data);
        setPaymentLoading(false);
      } else {
        setPaymentData([]);
        setPagination(null);
        setPaymentLoading(false);
      }
    } catch (error) {
      setPaymentData([]);
      setPagination(null);
      setPaymentLoading(false);
    }
  };

  useEffect(() => {
    handleFetchPayments(page);
  }, [page]);

  // Define a style function for the status box
  const getStatusStyle = (status) => {
    switch (status) {
      case "paid":
        return {
          backgroundColor: "#D9FFE4",
          color: "#077E2B",
        };
      case "Due":
        return {
          backgroundColor: "#FFF7DE",
          color: "#71590C",
        };
      case "In-process":
        return {
          backgroundColor: "#FFF7DE",
          color: "#71590C",
        };

      case "Failed":
        return {
          backgroundColor: "#FFE9E9",
          color: "#B21818",
        };
      default:
        return {
          backgroundColor: "#ECEFF1",
          color: "#455A64",
        };
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await getClasses(userId);
        setClassList(data?.data);
      } catch (err) {
        console.error("Could not fetch Classes");
        setClassList([]);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetTestTypes = async () => {
      try {
        const data = await getTestTypeList();
        setTestTypeList(data);
      } catch (err) {
        console.error("Could not fetch test types");
      } finally {
        console.error("Could not fetch test types");
      }
    };

    fetTestTypes();
  }, []);

  

    useEffect(() => {
    const fetTestTypes = async () => {
      try {
        const data = await getAllSubTestTypeList();
        setSubTestTypeList(data?.data);
      } catch (err) {
        console.error("Could not fetch test types");
      } finally {
        console.error("Could not fetch test types");
      }
    };

    fetTestTypes();
  }, []);

  // fetch modes
  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await getPaymentModes();
        setPaymentModeList(data?.data);
      } catch (err) {
        console.error("Could not fetch payment mode");
        setPaymentModeList([]);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await getPaymentStatus();
        setStatusList(data?.data);
      } catch (err) {
        console.error("Could not fetch payment mode");
        setStatusList([]);
      }
    };
    fetchData();
  }, []);

  // Apply Filter
  const handleApplyFilter = async (page) => {
    if (
      duration === "custom" &&
      (paymentStartDate === null || paymentStartDate === "")
    ) {
      setErrorMessage("Please select start date");
      handleOpenErrorPopup();
      return;
    }
    if (
      duration === "custom" &&
      (paymentEndDate === null || paymentData === "")
    ) {
      setErrorMessage("Please select end date.");
      handleOpenErrorPopup();
      return;
    }

    if (duration === "custom" && paymentStartDate > paymentEndDate) {
      setErrorMessage("Start date should be less than end date.");
      handleOpenErrorPopup();
      return;
    }
    setPaymentLoading(true);

    try {
      const response = await getTestPaymentHistory({
        user_id: parseInt(userId),
        test_type_id: testType,
        sub_test_type_id: SubtestType,
        payment_mode: paymentMode,
        page,
        limit: 3,
        status: status,
        start_date: paymentStartDate,
        end_date: paymentEndDate,
        filter: duration,
      });

      if (response.status === 200) {
        setPaymentData(response?.data);
        setPagination(response?.pagination);

        setPaymentLoading(false);
      } else {
        setPaymentData([]);
        setPagination(null);
        setPaymentLoading(false);
      }
    } catch (error) {
      setPaymentData([]);
      setPagination(null);
      setPaymentLoading(false);
    }
  };

  // reset filter

  const handleReset = () => {
    setSubTestType([]);
    setTestType([])
    setStatus([]);
    setPaymentMode([]);
    setPagination(originalPagination);
    setPaymentData(originalPayment);
    setPayemntEndDate("");
    setPayemntStartDate("");
    setPage(1);
    setDuration("last_30_days");
  };

  const handleGerateReceipt = async (provisional_payments_id) => {
    setReceiptLoading(true);
    try {
      const response = await genrateTestPaymentReceipt({
        user_id: parseInt(userId),
        rt_provisional_payments_id: provisional_payments_id,
      });

      if (response.status === 200) {
        const receipt = response?.data;
        setReceiptData(receipt);
        setReceiptLoading(false);
        // navigate("/view-payment-receipt", {
        //   state: { receiptData: receipt },
        // });

        // 👇 Generate the PDF blob and trigger download automatically
        const blob = await pdf(
           <TestPaymentReceipt receiptData={receipt} />
        ).toBlob();
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `Payment_Receipt_${provisional_payments_id}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      } else {
        setReceiptData([]);
        setReceiptLoading(false);
        setErrorMessage(
          "Oops! Something went wrong while trying to download your receipt"
        );
        handleOpenErrorPopup();
      }
    } catch (error) {
      setReceiptData([]);

      setReceiptLoading(false);
      setErrorMessage(
        "Oops! Something went wrong while trying to download your receipt"
      );
      handleOpenErrorPopup();
    }
  };

  // error popup

  const handleOpenErrorPopup = () => {
    setOpenErrorPopup(true);
  };

  const handleCloseErrorPopup = () => {
    setOpenErrorPopup(false);
  };
  const redirectionLink = "/test-prep/performance/purchase-test";
  return (
    <>
      <Backdrop open={receiptLoading} style={{ zIndex: 9999 }}>
        <Loader text="Genarting Payment Receipt..." />
      </Backdrop>
      <Grid container spacing={2}>
        <Grid item xs={12} md={12}>
          <Collapse in={expanded}>
            <GlobalCard padding="30px">
              <Grid
                container
                // display="flex"
                // flexDirection="row"
                // alignItems="center"
                // flexWrap="wrap"
                gap={2}
                rowGap={3}
              >
                <Grid item xs={12} sm={5.5} md={2.2}>
                  <CustomSelect
                    multiple
                    // minWidth={200}
                    fullWidth
                    color="#3F424C"
                    fontWeight={400}
                    options={testTypeList}
                    value={testType}
                    label="Test Type"
                    getOptionLabel={(opt) => opt?.name}
                    getOptionValue={(opt) => opt?.id}
                    onChange={(e) => {
                      setTestType(e.target.value);
                    }}
                  />
                </Grid>

                {/* <Grid item xs={12} sm={5.5} md={2.2}>
                  <CustomSelect
                    color="#3F424C"
                    fontWeight={400}
                    // minWidth={200}
                    fullWidth
                    multiple
                    label="Status"
                    options={statuslist}
                    value={status}
                    getOptionLabel={(opt) => opt?.status}
                    getOptionValue={(opt) => opt?.id}
                    onChange={(e) => {
                      setStatus(e.target.value);
                    }}
                  />
                </Grid> */}

    <Grid item xs={12} sm={5.5} md={2.2}>
                  <CustomSelect
                    multiple
                    // minWidth={200}
                    fullWidth
                    color="#3F424C"
                    fontWeight={400}
                    options={subTestTypeList}
                    value={SubtestType}
                    label="Sub Test Type"
                    getOptionLabel={(opt) => opt?.name}
                    getOptionValue={(opt) => opt?.id}
                    onChange={(e) => {
                      setSubTestType(e.target.value);
                    }}
                  />
                </Grid> 

                <Grid item xs={12} sm={5.5} md={2.2}>
                  <CustomSelect
                    color="#3F424C"
                    fontWeight={400}
                    // minWidth={200}
                    fullWidth
                    options={durationOption}
                    value={duration}
                    label="Payment Date Range"
                    getOptionLabel={(opt) => opt?.label}
                    getOptionValue={(opt) => opt?.value}
                    onChange={(e) => {
                      setDuration(e.target.value);
                      setPayemntStartDate(null);
                      setPayemntEndDate(null);
                    }}
                  />
                </Grid>

                {duration === "custom" && (
                  <>
                    <Grid item xs={12} sm={5.5} md={2.2}>
                      <CustomTextField
                        label="Payment Start Date"
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                        type="date"
                        borderColor="#57257533"
                        fontSize={14}
                        value={paymentStartDate}
                        onChange={(e) => setPayemntStartDate(e.target.value)}
                        borderRadius="8px"
                        color="#121926"
                        fontWeight={400}
                        inputProps={{
                          max: todaysDate, // disable all dates after today
                        }}
                      />
                    </Grid>

                    <Grid item xs={12} sm={5.5} md={2.2}>
                      <CustomTextField
                        label="Payment End Date"
                        InputLabelProps={{ shrink: true }}
                        type="date"
                        fullWidth
                        color="#121926"
                        borderColor="#57257533"
                        value={paymentEndDate}
                        onChange={(e) => setPayemntEndDate(e.target.value)}
                        fontSize={14}
                        borderRadius="8px"
                        fontWeight={400}
                        inputProps={{
                          min: paymentStartDate,
                        }}
                      />
                    </Grid>
                  </>
                )}

                <BlueMediumButton
                  buttonTitle="Apply"
                  onClick={() => handleApplyFilter(1)}
                  endIcon={
                    <img src="/newdashboard/Payment History/Group 1171284122.png" />
                  }
                />

                <BlueOutlinedButton
                  buttonTitle="Reset"
                  onClick={handleReset}
                  endIcon={
                    <img
                      src="/newdashboard/Payment History/rotation.png"
                      style={{ width: 18 }}
                    />
                  }
                />
              </Grid>
            </GlobalCard>{" "}
          </Collapse>
        </Grid>

        {paymentLoading ? (
          <Grid item xs={12}>
            <Loader text="Loading Payments..." />
          </Grid>
        ) : paymentData && paymentData.length > 0 ? (
          paymentData.map((payment, index) => (
            <Grid item xs={12} mt={1} key={index}>
              <Card
                sx={{
                  borderRadius: "12px",
                  boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                  borderLeft: "3px solid #DA5DC7", // purple left border
                  mb: 2,
                  p: "15px",
                }}
              >
                <Box
                  display="flex"
                  justifyContent="space-between"
                  flexWrap="wrap"
                  alignItems="center"
                  mb={2}
                >
                  <Typography
                    color="#572575"
                    fontFamily="Inter"
                    fontSize="16px"
                    lineHeight="100%"
                    letterSpacing="0px"
                    fontWeight={600}
                  >
                    {payment?.rt_product_id?.sub_test_type_id?.name}{" "}
                   ( {payment?.rt_product_id?.product_name} -{" "}
                    <span style={{ color: "#222222", fontWeight: 500 }}>
                      {" "}
                      {payment?.rt_product_id?.question_quantity} Questions
                    </span>)
                  </Typography>

                  <Box
                    sx={{
                      borderRadius: "6px",
                      fontSize: "14px",
                      px: 2,
                      py: 0.6,
                      fontFamily: "Inter",
                      fontWeight: 400,
                      ...getStatusStyle(payment?.payment_status),
                    }}
                  >
                    {payment?.payment_status === "pending"
                      ? "Inprocess"
                      : payment?.payment_status
                      ? payment?.payment_status.charAt(0).toUpperCase() +
                        payment?.payment_status.slice(1)
                      : ""}
                  </Box>
                </Box>

                <Grid container spacing={2}>
                  <Grid item xs={12} md={4} lg={1.7}>
                    <Typography
                      color="#000000"
                      fontFamily="Inter"
                      fontWeight={300}
                      fontSize="16px"
                    >
                      Item Quantity
                    </Typography>
                    <Typography
                      color="#000000"
                      fontFamily="Inter"
                      fontSize="15px"
                      fontWeight={400}
                      mt={1.5}
                    >
                      {payment?.quantity}
                    </Typography>
                  </Grid>

                  <Grid item xs={12} md={4} lg={1.7}>
                    <Typography
                      color="#000000"
                      fontFamily="Inter"
                      fontWeight={300}
                      fontSize="16px"
                    >
                      Payment Date
                    </Typography>
                    <Typography
                      color="#000000"
                      fontFamily="Inter"
                      fontSize="15px"
                      fontWeight={400}
                      mt={1.5}
                    >
                      {payment?.payment_date}
                    </Typography>
                  </Grid>

                  <Grid item xs={12} md={4} lg={1.7}>
                    <Typography
                      color="#000000"
                      fontFamily="Inter"
                      fontWeight={300}
                      fontSize="16px"
                    >
                      Total Payment
                    </Typography>
                    <Typography
                      color="#000000"
                      fontFamily="Inter"
                      fontSize="15px"
                      fontWeight={400}
                      mt={1.5}
                    >
                      {payment?.currency} {payment?.amount_paid}
                    </Typography>
                  </Grid>

                  <Grid item xs={12} md={4} lg={1.7}>
                    <Typography
                      color="#000000"
                      fontFamily="Inter"
                      fontWeight={300}
                      fontSize="16px"
                    >
                      Pending
                    </Typography>
                    <Typography
                      color="#000000"
                      fontFamily="Inter"
                      fontSize="15px"
                      fontWeight={400}
                      mt={1.5}
                    >
                      {payment?.currency} {payment?.pending_amount || 0}
                    </Typography>
                  </Grid>

                  <Grid item xs={12} md={4} lg={1.7}>
                    <Typography
                      color="#000000"
                      fontFamily="Inter"
                      fontWeight={300}
                      fontSize="16px"
                    >
                      Payment Mode
                    </Typography>
                    <Typography
                      color="#000000"
                      fontFamily="Inter"
                      fontSize="15px"
                      fontWeight={400}
                      mt={1.5}
                    >
                      {payment?.payment_mode_id?.payment_mode}
                    </Typography>
                  </Grid>

                  {payment?.payment_status === "paid" && (
                    <Grid
                      item
                      xs={12}
                      md={12}
                      lg={3.5}
                      container
                      gap={1}
                      justifyContent="flex-end"
                      textAlign="end"
                      mt={1.5}
                    >
                      <BlueMediumButton
                        buttonTitle="Download Receipt"
                        startIcon={
                          <img
                            src="/newdashboard/Payment History/download.png"
                            alt="Download"
                          />
                        }
                        // onClick={() =>
                        //   navigate("/test-prep/view-payment-receipt")
                        // }

                        onClick={() => handleGerateReceipt(payment?.id)}
                      />
                    </Grid>
                  )}
                </Grid>
              </Card>
            </Grid>
          ))
        ) : (
          <Grid item xs={12} mt={5}>
            <NoClasseEnrolledScreen
              text="No Payment History"
              subText="You haven’t made any payments yet. Once you complete a transaction, your payment details will appear here. Keep exploring and learning — your journey is just beginning!"
              maxWidth={1000}
              buttonTitle="Explore Test"
              redirectionLink={redirectionLink}
            />
          </Grid>
        )}

        <Grid item xs={12} mt={2}>
          {pagination && (
            <CustomPafinationComp
              currentPage={pagination?.current_page}
              totalPages={pagination?.total_page}
              onPageChange={setPage}
            />
          )}
        </Grid>
      </Grid>

      <ErrorPopupScreen
        open={openErrorPopup}
        handleClose={handleCloseErrorPopup}
        subText={errorMessage}
        buttonTitle="Got It"
        // startIcon={<ArticleIcon />}
        // navigateLink="/test-prep/checkout"
        currentPathname={location.pathname}
        maxWidth="xs"
      />
    </>
  );
}
